import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

type DangerZoneRowProps = {
  label: string;
  description: string;
  action?: JsxNode;
};

export default function DangerZoneRow({ label, description, action }: DangerZoneRowProps) {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'error.main',
        borderRadius: 1,
        px: 2,
        py: 2,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', sm: 'center' }}
      >
        <Box>
          <Typography fontWeight="fontWeightBold">{label}</Typography>
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Typography color="text.secondary" variant="body2">
              {description}
            </Typography>
          </Stack>
        </Box>
        {action}
      </Stack>
    </Box>
  );
}
